/* eslint-disable */
export default {
  noResultFoundFor: '다음에 대한 결과가 없음',
  foundFromServerHint: '키워드를 입력하고 Enter 키를 눌러 {appName}에서 검색',
  notResultFoundFromServer: '검색 결과 없음',
  loading: '로드 중...',
} as const;

// @key: @#@"noResultFoundFor"@#@ @source: @#@"No result found for"@#@
// @key: @#@"foundFromServerHint"@#@ @source: @#@"Type keyword and press Enter to search in {appName}"@#@
// @key: @#@"notResultFoundFromServer"@#@ @source: @#@"No results found"@#@
// @key: @#@"loading"@#@ @source: @#@"loading..."@#@
